import React from 'react'
import { Tag } from 'antd'
import { SortOrder } from 'antd/lib/table/interface'

import { amountToCurrencyFormat } from '../../../../utils/format'

import { Call } from '../../../../context/types'

export const columns = [
	{
		title: 'Brand',
		dataIndex: 'brand.name',
		key: 'brand.name',
		render: (_: string, call: Call) => {
			return <span>{`${call.brand.name}`}</span>
		},
	},
	{
		title: 'Channel',
		dataIndex: 'channel.name',
		key: 'channel.name',
		defaultSortOrder: 'descend' as SortOrder,
		sortDirections: ['descend', 'ascend'] as SortOrder[],
		sorter: (a: any, b: any) => a.channel.name.toLowerCase().localeCompare(b.channel.name.toLowerCase()),
		render: (_: any, v: Call) => {
			return <span>{`${v.channel.name}`}</span>
		},
	},
	{
		title: 'User',
		dataIndex: 'user.last_name',
		key: 'user.last_name',
		defaultSortOrder: 'descend' as SortOrder,
		sortDirections: ['descend', 'ascend'] as SortOrder[],
		sorter: (a: any, b: any) => a.user.first_name.toLowerCase().localeCompare(b.user.first_name.toLowerCase()),
		render: (_: any, v: Call) => {
			return <span>{`${v.user.first_name} ${v.user.last_name}`}</span>
		},
	},
	{
		title: 'At',
		dataIndex: 'start_time',
		key: 'start_time',
		defaultSortOrder: 'descend' as SortOrder,
		sortDirections: ['descend', 'ascend'] as SortOrder[],
		sorter: (a: any, b: any) => new Date(a.start_time).getTime() - new Date(b.start_time).getTime(),
		render: (_: any, v: Call) => {
			const date = new Date(v.start_time)
			return <span>{date.toLocaleString()}</span>
		},
	},
	{
		title: 'My Fee',
		dataIndex: 'fee_to_expert',
		key: 'callPricing.fee_to_expert',
		defaultSortOrder: 'descend' as SortOrder,
		sortDirections: ['descend', 'ascend'] as SortOrder[],
		sorter: (a: any, b: any) => {
			const aValue = a.fee_to_expert || a.fee_to_charity
			const bValue = b.fee_to_expert || b.fee_to_charity
			return aValue - bValue
		},
		render: (fee_to_expert: any, v: Call) => {
			const fee = fee_to_expert || v.fee_to_charity
			return <span>${amountToCurrencyFormat(fee)}</span>
		},
	},
	{
		title: 'Processed On',
		dataIndex: 'expert_paid_on',
		key: 'callPricing.expert_paid_on',
		render: (expert_paid_on: any, v: Call) => {
			if (+v.fee_to_expert === 0) {
				return (
					<Tag color="#f5f5f5" style={{ color: '#595959', borderColor: '#595959' }}>
						{'NA'}
					</Tag>
				)
			}
			if (!expert_paid_on) return <span>{'Not Yet'}</span>
			const date = new Date(expert_paid_on)
			return <span>{date.toLocaleString()}</span>
		},
	},
	{
		title: 'Paid To',
		dataIndex: 'fee_to_charity',
		key: 'callPricing.fee_to_charity',
		render: (fee_to_charity: any) => {
			return !!fee_to_charity ? <Tag color="geekblue">Charity</Tag> : <Tag color="volcano">Me</Tag>
		},
	},
]
